import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ImageSkeleton,
  LineSkeleton,
} from "../../Components/Utility/Skeletons";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";
import {fetchCmsMetaData} from "../../Components/Utility/cmsMetaService";

function HostCategory() {
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [experience, setExperience] = useState(null);
  const token = localStorage.getItem("authToken");
  const [meta,setMeta] = useState();

  const navigate = useNavigate();

  const fetchCategory = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/get-category`
      );
      setCategory(res.data);
    } catch (error) {
      console.error("error when fetching category", error);
    } finally {
      setLoading(false);
    }
  };

  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const fetchExperience = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/get-host-experience`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setExperience(res.data);

      // ✅ Save category_id if exists
      if (res.data?.data?.category_id) {
        setSelectedCategoryId(res.data.data.category_id);
      }
    } catch (error) {
      console.error("error when fetching experience", error);
    }
  };

  useEffect(() => {
    fetchCategory();
    fetchExperience();
    
    const saved = localStorage.getItem("hostData");
  if (saved) {
    const parsed = JSON.parse(saved);
    if (parsed.categoryId) {
      setSelectedCategoryId(Number(parsed.categoryId));
    }
  }
  }, []);

  // ✅ Handle click on category
  const handleCategoryClick = (id) => {
    setSelectedCategoryId(id);
    // localStorage.setItem("hostData", id);
    // localStorage.setItem("hostData", JSON.stringify({ categoryId: id }));
     const existingData = JSON.parse(localStorage.getItem("hostData")) || {};
  const updatedData = { ...existingData, categoryId: id };
  localStorage.setItem("hostData", JSON.stringify(updatedData));
    navigate("/host-subcategory", { state: { categoryId: id } });
  };


   useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("category");
      setMeta(data);
    };

    loadMeta();
  }, []);

  return (
    <>
      <section class="ser_v_araeea allpages what_experience al_bootm_spance">
         <SetMetaTags
        title= {meta?.meta_title || "Category Selection | Weyfarin"}
        description={meta?.meta_description || "Category Selection | Weyfarin"}
      
      />
        <div class="container">
          <div class="abt_pgs_areea">
            {loading ? (
              <LineSkeleton width="300px" height="24px" margin="0 auto 20px" />
            ) : (
              <h2>What experience will you offer to guests</h2>
            )}
          </div>
          <div class="categary_listst justy_centr">
            {loading &&
              Array(6)
                .fill(0)
                .map((_, index) => (
                  <div className="items_bx" key={index}>
                    <ImageSkeleton
                      width="150px"
                      height="150px"
                      borderRadius="12px"
                    />
                    <LineSkeleton
                      width="100px"
                      height="16px"
                      margin="8px auto 0"
                    />
                  </div>
                ))}

            {!loading && !category?.data?.length && (
              <p>No categories available</p>
            )}
            {!loading &&
              category?.data?.map((item) => (
                <div
                  className={`items_bx ${
                    selectedCategoryId === item.id ? "selected-category" : ""
                  }`}
                  key={item.id}
                  onClick={() => handleCategoryClick(item.id)}
                >
                  <div class="mg_area_sc">
                    <img
                      src={`${category.base_url}${item.image}`}
                      alt={item.categor}
                    />
                  </div>
                  <p>{item.category}</p>
                </div>
              ))}

            {/* <div class="items_bx">
		 <a href="#">
		  <div class="mg_area_sc"><img src="images/what_experience_sm2.png" alt="" /></div>
		  <p>Fitness and wellness</p>
		 </a>
		</div> */}

            {/* <div class="items_bx">
		 <a href="#">
		  <div class="mg_area_sc"><img src="images/what_experience_sm3.png" alt="" /></div>
		  <p>Food and drink</p>
		 </a>
		</div>
		
		
		
		<div class="items_bx">
		 <a href="#">
		  <div class="mg_area_sc"><img src="images/what_experience_sm4.png" alt="" /></div>
		  <p>History and culture</p>
		 </a>
		</div>
		
		
		<div class="items_bx">
		 <a href="#">
		  <div class="mg_area_sc"><img src="images/what_experience_sm5.png" alt="" /></div>
		  <p>Nature and outdoors</p>
		 </a>
		</div> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default HostCategory;
